import { createWebSocketStore } from 'src/components/#services/helpers';
export const getQuestsAnalytics = createWebSocketStore({
    auth: true,
    requestTemplate: {
        agent: 'analytics',
        auth: { type: 'webSite' },
        lang: 'en',
        method: 'quests_getAnalytics',
    },
    getResult(value) {
        return Object.assign({}, value);
    },
});
